import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            background-color: ${COLORS.background.base};
            text-transform: uppercase;
            font-size: ${TYPOGRAPHY.size.smallest};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    null,
                    null,
                ])}
        `,
        perPageSelect: css`
            display: flex;
            flex-grow: 1;
            label {
                padding-top: 0px;
                text-overflow: unset;
                overflow: unset;
                white-space: unset;
                width: auto;
                text-align: center;
            }
            > div {
                width: 100%;
                justify-content: center;
                padding-right: 0;
                > div {
                    select {
                        height: 100%;
                        padding-right: 0px !important;
                    }
                    span {
                        top: 50% !important;
                        left: 50%;
                        transform: translate(0px, -50%);
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                justify-content: right;
                            `,
                        ],
                        "min",
                    )}
            }
        `,
        currentButton: css`
            min-height: 30px;
            background: ${getColor("primary")};
            border-radius: 0;
            span {
                color: ${COLORS.white}!important;
            }
            &:hover {
                background: ${getColor("primary")};
            }
        `,
    },
    buttonProps: {
        mergeCss: true,
        css: css`
            border-radius: 0;
            border: none;
            color: ${getColor("text.main")};
            [class^="TypographyStyle"] {
                color: inherit;
            }
            &:hover {
                background: ${COLORS.border.base};
            }
            &:active {
                background: ${COLORS.border.base};
            }
        `,
    },
};
